import type React from 'react';

import type { InteractiveEmailInquiryComponent } from 'api/types';
import UserMessage from 'components/UserMessage';
import { Typography } from '@forethought-technologies/forethought-elements';
import { TextDivider } from './TextDivider';
import { Box } from '@mui/material';

interface InteractiveEmailInquiryStepProps {
  stepIndex: number;
  widgetComponent: InteractiveEmailInquiryComponent;
}

const InteractiveEmailInquiryStep: React.FC<
  React.PropsWithChildren<InteractiveEmailInquiryStepProps>
> = ({ stepIndex, widgetComponent }) => {
  const { source_body: sourceBody, source_title: sourceTitle } =
    widgetComponent.component_fields;

  return (
    <>
      <UserMessage stepIndex={stepIndex}>
        <Typography variant='font14Bold'>{sourceTitle}</Typography>
        <br />
        <Typography variant='font14'>{sourceBody}</Typography>
      </UserMessage>
      <Box margin='12px 0 28px'>
        <TextDivider text='Interactive Email with virtual assistance' />
      </Box>
    </>
  );
};

export default InteractiveEmailInquiryStep;
